import React from 'react';
import { Joyride } from 'react-joyride';
import type { EventData } from 'react-joyride';

interface GuidedTourProps {
  steps: any[];
  run: boolean;
  tourKey: number;
  onCallback: (data: EventData) => void;
}

const GuidedTour: React.FC<GuidedTourProps> = ({ steps, run, tourKey, onCallback }) => {
  return (
    <Joyride
      key={`tour-${tourKey}`}
      steps={steps}
      run={run}
      continuous
      scrollToFirstStep
      onEvent={onCallback}
      locale={{
        back: 'Indietro',
        close: 'Chiudi',
        last: 'Fine',
        next: 'Avanti',
        skip: 'Non mostrare più'
      }}
      options={{
        primaryColor: '#16a34a',
        zIndex: 10000,
        buttons: ['back', 'close', 'primary'],
        showProgress: true,
        scrollOffset: 80,
        textColor: '#374151',
        arrowColor: '#ffffff',
        backgroundColor: '#ffffff',
        width: 340
      }}
      styles={{
        tooltip: {
          borderRadius: 12,
          padding: 20,
          fontFamily: 'inherit',
          fontSize: 13
        }
      } as any}
    />
  );
};

export default GuidedTour;
